/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IWorkoutType {
  Cardio = 'cardio',
  Cycle = 'cycle',
  Run = 'run',
  Fusion = 'fusion',
  Row = 'row',
  Strength = 'strength',
}
